<template>
  <div>
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="handleConfirm"
      :title="isEdit ? name + '-值-时间表' : '值-时间表'" :has-form="true" class="time-event-dialog-modal" top="15%" width="36%"
      @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="时间规划" name="second">
          <gs-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <gs-checkbox v-for="city in cities" :label="city" :key="city" style="margin:10px">{{ city
            }}</gs-checkbox>
          </gs-checkbox-group>

          <div style="margin-top: 8px;margin-left: 15px;display: flex;align-items: center;">
            <span style="font-size: 12px">开始时间：</span>
            <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.startTime" format="HH:mm" />
            <span style="font-size: 12px;margin-left: 15px">结束时间：</span>
            <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.stopTime" format="HH:mm" />
            <div style="float: right;margin-top: 2px;margin-left: 20px;">
              <span style="color: #ff7f00;cursor: pointer;font-size: 13px;" @click="handleConfirmData">创建</span>
            </div>
          </div>

          <el-table size='mini' :data="timeChartList"
            :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
            style="width: 100%;margin-top:15px">
            <el-table-column prop="startTime" label="开始时间" align="center">
            </el-table-column>
            <el-table-column prop="stopTime" label="结束时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <i style="margin-left:20px" class="el-icon-delete-solid" @click="delTime(scope)"></i>
              </template>
            </el-table-column>
          </el-table>
        </gs-tab-pane>
        <gs-tab-pane label="联动数据" name="end">
          <div>
            <div style="width: 100%;height: 50px;"><span style="color: #FF7F00;cursor: pointer;"
                @click="addressChange">选择触发点位</span>
              <span>{{ triggerObj.fullName }}</span>
            </div>
            <!--  <span @click="add" style='color:#ff7f00;cursor: pointer;'>对象列表</span>
            <div class="form-item-objectSeries">
              <el-table :data="objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%" height="220">
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center">
                </el-table-column>
                <el-table-column label="开始值" align="center">
                  <template slot-scope="scope">

                    <gs-input style="margin-top: 0px;margin-bottom:0px" v-show="true" v-model="scope.row.startnum" />

                  </template>
                </el-table-column>
                <el-table-column label="结束值" align="center">
                  <template slot-scope="scope">

                    <gs-input v-show="true" v-model="scope.row.stopnum" />

                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete-solid" @click="delObjectData(scope)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div> -->
          </div>
        </gs-tab-pane>
      </gs-tabs>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" top="15%"
      @close="beforeCloseAdd" @confirm="handleConfirmAdd">
      <div style="height: 500px;overflow-y: auto">
        <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>


    <gs-modal v-model="visibleAdd1" :before-close="beforeCloseAdd1" class="my-test-class" title="添加"
      @close="beforeCloseAdd1" @confirm="handleConfirmAdd1" top="100px">
      <div style="height: 400px;overflow: auto;" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <gs-tree v-if="visibleAdd1" ref="tree1" :data="addList1" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import datePicker from '../datePicker/dayPicker'
import exchangeTime from '../../utils/timeExchange.js'
import newAdd from './timeChartNewAdd'
import eventBus from './vue.js'
import allEvent from './allEvent'
import moment from 'moment'
const WEEK_MAP = {
  '星期一': 1,
  '星期二': 2,
  '星期三': 3,
  '星期四': 4,
  '星期五': 5,
  '星期六': 6,
  '星期日': 7
}
export default {
  name: '',
  props: [''],
  data() {
    return {
      pointType: "1",
      loading: false,
      isEdit: false,
      name: '',
      activeName: 'first',
      description: '',
      checkedCities: [],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      timeType: 1,
      formDatas: {
        startTime: moment(),
        stopTime: moment()
      },
      form: {

      },
      timeChartList: [],
      objectSeries: [],
      visibleAdd: false,
      visibleAdd1: false,
      addList: [],
      addList1: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      triggerObj: {},// 触发点位
      sendData: {
        "name": "",
        "type": "value_timeChart",
        "parentId": "",
        "description": "",
        "attribute": {
          "parentId": "",
          "task": [
          ],
          "status": true,
          "objectSeries": [],
          "condition": "a==1",
          "conditionRealTimeValue": [],
          "conditionNotRealTimeValue": [],
          "conditionFormulaMap": {},
          "conditionFormulaValue": [],
          "conditionEchoMap": {},
          "conditionObjectServices": []
        }
      },
    };
  },

  components: {},

  computed: {
    ...mapState({
      visible: 'timeChartValueShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    visible() {
      if (this.visible) {
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type == 'value_timeChart') {
          console.log(this.objectData, "这个因该是修改")
          this.name = this.objectData.name
          this.description = this.objectData.description
          this.timeChartList = this.taskToTimeChartList(this.objectData.attribute.task)
          console.log(this.timeChartList, "timeChartList")
          this.objectSeries = this.objectData.attribute.objectSeries
          this.triggerObj = this.objectData.attribute.conditionObjectServices[0]
          this.checkedCities = this.timeChartList[0].weeks
        } else {
          console.log(this.objectData, "这个因该是新建，")
          this.clearData()
        }
      } else {
        this.clearData()
      }
    }
  },

  beforeMount() { },

  mounted() { },

  methods: {
    ...mapMutations({
      close: 'TIME_CHART_VALUE_HIDE'
    }),
    beforeClose() {
      this.clearData()
      this.close()
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    beforeCloseAdd1() {
      this.visibleAdd1 = false
    },
    beforeConfirm(e, done) {
      this.clearData()
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      debugger
      // 去整理数据按照后端的数据格式
      const task = this.buildTaskList(
        this.timeChartList,
      )
      this.conditionData()
      this.sendData.name = this.name
      this.sendData.description = this.description
      this.sendData.parentId = this.nodeData.id
      this.sendData.attribute.task = task
      this.sendData.attribute.objectSeries = this.objectSeries
      this.sendData.attribute.parentId = this.nodeData.id
      service.newAddPoint(this.sendData).then(res => {
        this.$message.success("创建成功")
      })
      this.clearData()
      this.close()
    },
    handleCheckedCitiesChange(value) {
      console.log(this.checkedCities)
    },
    handleConfirmData() {
      if (!this.checkedCities.length) {
        this.$Message.warning('请选择星期')
        return
      }
      if (!this.formDatas.startTime || !this.formDatas.stopTime) {
        this.$Message.warning('请选择开始和结束时间')
        return
      }
      // 开始 / 结束 cron
      const startCron = this.buildWeekCron(
        this.formDatas.startTime,
        this.checkedCities
      )
      const endCron = this.buildWeekCron(
        this.formDatas.stopTime,
        this.checkedCities
      )
      // 表格展示 & 后台提交都靠这个对象
      this.timeChartList.push({
        weeks: [...this.checkedCities],
        startTime: moment(this.formDatas.startTime).format('HH:mm'),
        stopTime: moment(this.formDatas.stopTime).format('HH:mm'),
        startCron,
        endCron
      })
      console.log(this.timeChartList)
    },
    delTime(scope) {
      this.timeChartList.splice(scope.$index, 1)
    },
    buildWeekCron(time, checkedCities) {
      if (!time || !checkedCities.length) return ''
      const hour = moment(time).format('HH')
      const minute = moment(time).format('mm')
      const weeks = checkedCities.map(w => WEEK_MAP[w]).join(',')
      // Quartz cron
      return `0 ${minute} ${hour} ? * ${weeks}`
    },
    add() {
      let _this = this
      if (this.addData) {
        this.$Message.warning('无法添加点位')
      } else {
        service.getTree('Point', _this.objectData.id).then(res => {
          console.log(res)
          this.addList = res
          if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
            setTimeout(() => {
              _this.form.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })
            }, 0)
          }
        })
        this.visibleAdd = true
      }
    },
    delObjectData(scope) {
      this.objectSeries.splice(scope.$index, 1);
    },
    handleConfirmAdd() {
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.objectSeries.push(e.data)
      })
      this.objectSeries = this.unique(this.objectSeries, 'id')
      this.visibleAdd = false
    },
    checkEvent(node, isSelect, halfSelect) { },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    addressChange() {
      this.pointType = "1"
      this.addList1 = [];
      let _this = this;
      this.visibleAdd1 = true;
      if (this.nodeData.type == "project" || this.nodeData.type == "server") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 30000);
        setTimeout(() => {
          service.getAllTree().then((res) => {
            _this.addList1 = res;
          });
        }, 1000);
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          _this.addList1 = res;
        });
      } else {
        service.getTree("Point", this.nodeData.id).then((res) => {
          this.addList1 = res;
        });
      }
    },
    handleConfirmAdd1() {
      const checkedNodes = this.$refs.tree1.getCheckedNodes(true)
      if (!checkedNodes.length) {
        this.$Message.warning('请选择一个点位')
        return
      }
      const selectedPoint = checkedNodes[0].data
      if (this.pointType === "1") {
        // 触发点位
        this.triggerObj = selectedPoint
      } else {
        // ★ 变量绑定点位
        if (!this.tableObj) return
        this.tableObj.name = selectedPoint.name
        this.tableObj.address = selectedPoint.fullName
        this.tableObj.pointData = selectedPoint   // ★完整绑定
      }
      this.visibleAdd1 = false
    },
    checkEvent(node, isSelect, halfSelect) {
      let leafCheckArr = this.$refs.tree1.getCheckedKeys();
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach((item) => {
          if (item != node.id) {
            this.$refs.tree1.setChecked(item, false);
          }
        });
      }
    },
    // cron组装
    buildTaskList(timeChartList) {
      const task = []
      timeChartList.forEach(item => {
        if (item.startCron) {
          task.push({
            cron: item.startCron,
            value: '1'
          })
        }

        if (item.endCron) {
          task.push({
            cron: item.endCron,
            value: '0'
          })
        }
      })

      return task
    },
    // 条件公式
    conditionData() {
      // 存储条件公式里的实时数据
      if (this.triggerObj.realTime) {
        this.sendData.attribute.conditionRealTimeValue.push(this.triggerObj.id)
      } else {
        this.sendData.attribute.conditionNotRealTimeValue.push(this.triggerObj.id)
      }
      // 条件公式对应关系判断
      this.sendData.attribute.conditionFormulaMap = { "a": this.triggerObj.id }
      // 条件公式里的实时数据+条件公式里的非实时数据
      this.sendData.attribute.conditionFormulaValue.push(this.triggerObj.id)
      // 条件公式里的变量和点位位置对应关系
      this.sendData.attribute.conditionEchoMap = { "a": this.triggerObj.fullName }
      // 存储点位
      this.sendData.attribute.conditionObjectServices.push(this.triggerObj)
    },
    // 清空数据
    clearData() {
      this.name = '';
      this.objectSeries = [];
      this.triggerObj = {};
      this.description = '';
      this.timeChartList = [];
      this.checkedCities = [];
      this.sendData = {
        "name": "",
        "type": "value_timeChart",
        "parentId": "",
        "description": "",
        "attribute": {
          "parentId": "",
          "task": [
          ],
          "status": true,
          "objectSeries": [],
          "condition": "a==1",
          "conditionRealTimeValue": [],
          "conditionNotRealTimeValue": [],
          "conditionFormulaMap": {},
          "conditionFormulaValue": [],
          "conditionEchoMap": {},
          "conditionObjectServices": []
        }
      }
    },

    taskToTimeChartList(task) {
      if (!task || !task.length) return []

      const weekMap = {
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六',
        7: '星期日'
      }

      // 找开始和结束
      let startItem = task.find(t => t.value === '1')
      let endItem = task.find(t => t.value === '0')

      if (!startItem || !endItem) return []

      // 解析 cron
      const parse = (cron) => {
        const arr = cron.split(' ')
        const minute = arr[1]
        const hour = arr[2]
        const weeks = arr[5]

        return {
          time: `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`,
          weeks: weeks.split(',').map(w => weekMap[w])
        }
      }

      const startParse = parse(startItem.cron)
      const endParse = parse(endItem.cron)

      return [
        {
          startCron: startItem.cron,
          endCron: endItem.cron,
          startTime: startParse.time,
          stopTime: endParse.time,
          weeks: startParse.weeks
        }
      ]
    }
  },



}

</script>
<style lang='' scoped>

</style>


// WEBPACK FOOTER //
// src/components/timeChart/timeChartValue.vue